import Vue from 'vue';
import { 
  Button,
  Cell,
  CellGroup,
  Field,
  Popup,
  Toast,
  Dialog,
  Picker,
  DatetimePicker,
  Search,
  Form,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Area,
  Step,
  Steps,
  Uploader,
  Progress,
  Image as VanImage,
  ImagePreview,
  Icon
} from 'vant';

// 注册Vant组件
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Search);
Vue.use(Form);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Area);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Uploader);
Vue.use(Progress);
Vue.use(VanImage);
Vue.use(ImagePreview);
Vue.use(Icon);

// 在原型上挂载一些组件的方法，便于全局调用
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$imagePreview = ImagePreview; 